
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {DialogTransferComponent} from '../../dialog-transfer/dialog-transfer.component';

@Component({
  selector: 'app-records-content',
  templateUrl: './records-content.component.html',
  styleUrls: ['./records-content.component.scss']
})
export class RecordsContentComponent implements OnInit {
  @Input() r;
  @Output() ondelete = new EventEmitter();
  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }
  onDelete(id) {
    this.ondelete.emit(id);
  }
  openDialog(record) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = record;
    const dialogRef = this.dialog.open(DialogTransferComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
        data => console.log('Form data', data)
        // connect with service
    );
  }
}
